<template>
  <blank-view :bodyStyle="{overflow:'hidden'}">
    <div slot="action">
      <a-button
        type="primary"
        style="margin-right:8px"
        @click="showCreate = true"
        v-acl="'page_bill_manage_add'"
      >{{this.$t("create")}}</a-button>
      <a-button
        type="danger"
        :disabled="!selectedRowKeys.length"
        @click="handleDelete"
        v-acl="'page_bill_manage_delete'"
      >{{this.$t("delete")}}</a-button>
    </div>
    <div style="height:100%;display:flex;background:#f0f2f5;">
      <div style="background:white;width:300px;flex-shrink:0">
        <ul style="height:100%;overflow-y:auto">
          <li
            :class="['list-li', l.bizCode === activeCode ? 'active' : '']"
            style="height:auto;min-height:32px;line-height:32px;padding-left:16px;cursor:pointer"
            v-for="l in list"
            :key="l.id"
            @click="() => handleSelect(l.bizCode)"
          ><ellipsis tooltip :length=50>{{l.title}}-{{l.bizCode}}</ellipsis></li>
        </ul>
      </div>
      <div v-resize="'x'"></div>
      <div style="background:white; flex-grow:1;overflow:hidden;">
        <ml-table
          size="small"
          rowKey="id"
          :scroll="{y:wmHeight - 200,x:1600}"
          :defaultExpandAllRows="true"
          :canChangeColWidth="true"
          :dataSource="dataSource"
          :columns="columns"
          :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
          getCheckboxProps: this.getCheckboxProps
          }"
          :chooseArr='selectedRowKeys'
          @cancelChooseArr='cancelChooseArr'
        ></ml-table>
      </div>
      <a-modal
        :title="$t('edit')"
        :visible="showEdit"
        @cancel="showEdit = false"
        :extraStyle="{ paddingBottom: '50px' }"
      >
        <curd-form
          v-if="showEdit"
          ref="form1"
          :schema="schema"
          :defaultValue="editdata"
          :footer="null"
        />
        <div
          slot="footer"
        >
          <a-button style="margin-right:8px" @click="showEdit = false">{{this.$t("cancel")}}</a-button>
          <a-button type="primary" @click="handleEdit">{{this.$t("save")}}</a-button>
        </div>
      </a-modal>
    </div>
    <a-modal
      :title="$t('create')"
      :visible="showCreate"
      @cancel="showCreate=false"
    >
      <curd-form
        v-if="showCreate"
        ref="form"
        :schema="schema"
        :footer="null"
        :defaultValue="createData"
      />
      <template slot="footer">
        <a-button key="back" @click="showCreate = false">
          {{$t("cancel")}}
        </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleCreate">
          {{$t("ok")}}
        </a-button>
      </template>
    </a-modal>
  </blank-view>
</template>

<script>
import {
  TenantInitialFieldTypeServiceProxy,
  TenantInitialFieldServiceProxy,
} from "@/service-proxies/app-v2/system.service-proxies";
import CurdForm from "@/components/BaseCurd/form";

const tiftsp = new TenantInitialFieldTypeServiceProxy();
const tifsp = new TenantInitialFieldServiceProxy();
const options = {
  list: tiftsp.getInitialFieldTypelist.bind(tiftsp),
  retrieve: tifsp.getInitialFieldlist.bind(tifsp),
  create: tifsp.saveInitialField.bind(tifsp),
  update: tifsp.editInitialField.bind(tifsp),
  updateStatus: tifsp.editstatus.bind(tifsp),
  delete: tifsp.deleteInitialField.bind(tifsp),
};

const systemMap = {
  1: "yes",
  0: "no",
};

const typeMap = {
  1: "page_bill_manage_text",
  2: "page_bill_manage_number",
  3: "page_bill_manage_date",
  4: "page_bill_manage_option",
};

const requiredMap = {
  1: "yes",
  0: "no",
};

const showMap = {
  1: "page_bill_manage_form",
  2: "page_bill_manage_table",
  4: "page_bill_manage_search",
};

export default {
  components: {
    "curd-form": CurdForm,
  },
  computed: {
    schema() {
      return {
        bizCode: {
          label: this.$t("page_bill_manage_code"),
          type: "text",
          placeholder: this.$t('common_please_input') + this.$t("page_bill_manage_code"),
        },
        isSystem: {
          label: this.$t("page_bill_manage_system"),
          type: "radio",
          options: [
            {
              label: this.$t("yes"),
              value: 1,
            },
            {
              label: this.$t("no"),
              value: 0,
            },
          ],
        },
        code: {
          label: this.$t("page_bill_manage_no"),
          type: "input",
          placeholder: this.$t('common_please_input') + this.$t("page_bill_manage_no"),
        },
        title: {
          label: this.$t("page_bill_manage_title"),
          type: "input",
          placeholder: this.$t('common_please_input') + this.$t("page_bill_manage_title"),
        },
        type: {
          label: this.$t("page_bill_manage_type"),
          type: "select",
          placeholder: this.$t('please_select') + this.$t("page_bill_manage_type"),
          options: [
            {
              label: this.$t("page_bill_manage_text"),
              value: 1,
            },
            {
              label: this.$t("page_bill_manage_number"),
              value: 2,
            },
            {
              label: this.$t("page_bill_manage_date"),
              value: 3,
            },
            {
              label: this.$t("page_bill_manage_option"),
              value: 4,
            },
          ],
        },
        isRequired: {
          label: this.$t("page_bill_manage_required"),
          type: "radio",
          options: [
            {
              label: this.$t("yes"),
              value: 1,
            },
            {
              label: this.$t("no"),
              value: 0,
            },
          ],
        },
        isDisplay: {
          label: this.$t("page_bill_manage_display"),
          type: "select",
          placeholder: this.$t('please_select') + this.$t("page_bill_manage_display"),
          props: {
            mode: "multiple",
          },
          options: [
            {
              label: this.$t("page_bill_manage_form"),
              value: 1,
            },
            {
              label: this.$t("page_bill_manage_table"),
              value: 2,
            },
            {
              label: this.$t("page_bill_manage_search"),
              value: 4,
            },
          ],
        },
        tip: {
          label: this.$t("page_bill_manage_tip"),
          type: "input",
          placeholder: this.$t('common_please_input') + this.$t("page_bill_manage_tip"),
        },
        sort: {
          label: this.$t("page_bill_manage_sort"),
          type: "inputNumber",
          placeholder: this.$t('common_please_input') + this.$t("page_bill_manage_sort"),
        },
      };
    },
    columns() {
      return [
        {
          title: this.$t("actions"),
          key: "action",
          fix: "left",
          width: 80,
          customRender: (text, record) => {
            console.log();
            return (
              record.id && 
              <a
                disabled={
                  !this.$store.getters.buttons.includes("page_bill_manage_edit")
                }
                onClick={() => this.openEdit(record)}
              >
                {this.$t("edit")}
              </a>
            );
          },
        },
        {
          title: this.$t("page_bill_manage_status"),
          key: "status",
          fix: "left",
          width: 100,
          customRender: (text, record) => {
            return (
              record.id &&
              <a
                disabled={
                  !this.$store.getters.buttons.includes("page_bill_manage_edit")
                }
                onClick={() => this.toggleStatus(record)}
              >
                {record.status == 0
                  ? this.$t("page_bill_manage_status_1")
                  : this.$t("page_bill_manage_status_2")}
              </a>
            );
          },
        },
        {
          title: "Id",
          dataIndex: "id",
          // width: 80,
        },
        {
          title: this.$t("page_bill_manage_sort"),
          dataIndex: "sort",
          width: 80,
        },
        {
          title: this.$t("page_bill_manage_code"),
          dataIndex: "bizCode",
          width: 80,
        },
        {
          title: this.$t("page_bill_manage_system"),
          dataIndex: "isSystem",
          width: 80,
          customRender: (text, record) => {
            if(record.id) {
              return this.$t(systemMap[text]);
            }
          },
        },
        {
          title: this.$t("page_bill_manage_no"),
          dataIndex: "code",
        },
        {
          title: this.$t("page_bill_manage_title"),
          dataIndex: "t",
        },
        {
          title: this.$t("page_bill_manage_type"),
          dataIndex: "type",
          width: 80,
          customRender: (text, record) => {
            if(record.id) {
              return this.$t(typeMap[text]);
            }
          },
        },
        {
          title: this.$t("page_bill_manage_required"),
          dataIndex: "isRequired",
          width: 80,
          customRender: (text, record) => {
            if(record.id) {
              return this.$t(requiredMap[text]);
            }
          },
        },
        {
          title: this.$t("page_bill_manage_display"),
          dataIndex: "isDisplay",
          customRender: (text, record) => {
            if(record.id) {
              const arr = text.toString(2).split("");
              const length = arr.length - 1;
              const result = arr.reduceRight((total, item, index) => {
                if (item == 0) return total;
                if (total == "") {
                  return (
                    total + this.$t(showMap[Math.pow(2, length - index) * item])
                  );
                } else {
                  return (
                    total +
                    "," +
                    this.$t(showMap[Math.pow(2, length - index) * item])
                  );
                }
              }, "");
              return result || "";
            }
          },
        },
        {
          title: this.$t("page_bill_manage_tip"),
          dataIndex: "tip",
        },
      ];
    },
  },
  data() {
    return {
      loading: false,
      list: [],
      showCreate: false,
      showEdit: false,
      ...options,
      editdata: {},
      createData: {},
      dataSource: [],
      selectedRowKeys: [],
      activeCode: null,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    cancelChooseArr(val) {
      this.selectedRowKeys = [];
    },
    getCheckboxProps(record) {
    return ({
      style: {
        display: record.id ? 'block' : 'none'
      },
      props: {
        disabled: record.id ? false : true
      }
    })
  },
    async toggleStatus(data) {
      await this.updateStatus(data.id, 1 - Number(data.status));
      this.$message.success(this.$t("modify_success"));
      this.getData();
    },
    async handleEdit() {
      const data = await this.$refs.form1.manualSubmit();
      data.isDisplay = (data.isDisplay || []).reduce((total, item) => {
        total += Number(item);
        return total;
      }, 0);

      await this.update(data);
      this.$message.success(this.$t("modify_success"));
      this.showEdit = false;
      this.getData();
    },
    async handleCreate() {
      try {
        this.loading = true
        const data = await this.$refs.form.manualSubmit();
        data.isDisplay = (data.isDisplay || []).reduce((total, item) => {
          total += Number(item);
          return total;
        }, 0);

        await this.create(data);
        this.$message.success(this.$t("create_success"));
        this.showCreate = false;
        this.getData();
      } catch (error) {
        
      } finally {
        this.loading = false
      }
    },
    async handleDelete() {
      await this.delete(this.selectedRowKeys);
      this.$message.success(this.$t("delete_success"));
      this.getData();
    },
    handleSelect(code) {
      this.activeCode = code;
      this.createData = {
        bizCode: code,
      };
      this.getData();
    },
    _openEdit(data) {
      const arr = data.isDisplay.toString(2).split("");
      const length = arr.length - 1;

      const result = arr.reduceRight((total, item, index) => {
        if (item != 0) {
          total.push(Math.pow(2, length - index) * item);
        }
        return total;
      }, []);

      this.editdata = {
        ...data,
        isDisplay: result,
      };
      this.showEdit = true;
    },
    openEdit(data) {
      if (!this.showEdit) {
        this._openEdit(data);
        return;
      }

      const form = this.$refs.form1.form.getFieldsValue();
      const keys = Object.keys(form);
      let bool = true;
      for (let key of keys) {
        if (this.editdata[key] != form[key]) {
          bool = false;
          break;
        }
      }

      if (bool) {
        this._openEdit(data);
        return;
      }

      this.$confirm({
        title: this.$t("switch_tips_title"),
        content: this.$t("switch_tips_content"),
        onOk: () => {
          this._openEdit(data);
        },
        onCancel() {
          return;
        },
      });
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
    },
    async getList() {
      const data = await this.list();
      this.list = data;
      if (!data || data.length == 0) return;
      this.activeCode = data[0].bizCode;
      this.createData = {
        bizCode: data[0].bizCode,
      };
      this.getData();
    },
    async getData() {
      if (!this.activeCode) return;
      const data = await this.retrieve(this.activeCode);
      data.forEach((item) => {
        item.t = item.title;
      });
      // this.dataSource = data;

      let dataLength = data.length;
      let copy = JSON.parse(JSON.stringify(data));
      let needPush = 0;
      if(dataLength < 30) {
        needPush = 30 - dataLength;
        for(var k=0; k<needPush; k++) {
          let obj = {  
            // id: 'none'
          }
          copy.push(obj)  
        }
      }

      this.dataSource = JSON.parse(JSON.stringify(copy));

    },
  },
};
</script>

<style scoped>
.list-li:hover,
.list-li.active {
  background: #edf8fc;
}

.list-li span {
  display: inline-block;
  width: 100%;
  word-break: break-all;
}
</style>
